<template>
  <div
    class="px-3 h-[50px] flex items-center justify-between bg-white sticky left-0 right-0 top-0 z-[100]"
  >
    <menu-top />
    <avatar-header />
  </div>
</template>

<script lang="ts">
export default {
  name: 'GlobalHeader'
}
</script>
<script setup lang="ts">
import MenuTop from '@/components/menu-top/index.vue'
import AvatarHeader from '@/components/account/index.vue'
</script>
<style lang="scss"></style>
